/*
   This is meant for the top of the page -- which step are we on?
      1 -- select them
      2 -- buid a journey
      3 -- print your guide
      4 -- explore the museum
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import '../../css/JourneyNavProgress.css'
import { getCurrentNavStep } from '../../selectors/journeyState-selectors'

// static reference to the asset files even though we load them dynamically
import img1 from '../../assets/circle-1.png'
import img2 from '../../assets/circle-2.png'
import img3 from '../../assets/circle-3.png'
import img4 from '../../assets/circle-4.png'
import sel1 from '../../assets/circle-1-selected.png'
import sel2 from '../../assets/circle-2-selected.png'
import sel3 from '../../assets/circle-3-selected.png'
import sel4 from '../../assets/circle-4-selected.png'
const circles = [img1, img2, img3, img4]
const selected = [sel1, sel2, sel3, sel4]

const JourneyNavProgressPanel = props => {
   const label = props.label || [null, null, null, null, null]
   const index = label[0] ? label[0] - 1 : null
   const isActive = props.currentNavStep === label[0]
   const circleImage = (index <= circles.length) ? <img alt={`circle-${index}`} src={isActive ? selected[index] : circles[index]} /> : null
   const isCompleted = (props.currentNavStep > (index + 1))
   return (
      <div className={'nav-step medium-2 ' + (isActive ? 'active' : '') + (isCompleted ? 'completed' : '')}>
         <div className={'top'}>
          {!isCompleted && circleImage}
            <span className={'text-container'}>
            {isCompleted &&
              <span>{label[1]}</span>
            }
            {!isCompleted &&
              <span>{label[2]} <span className={'secondary'}>{label[3]}</span></span>
            }
            </span>
         </div>
         <div className={'bottom small-3'}>
            {label[4]}
         </div>
      </div>
   )
}

const mapStateToProps = (state, ownProps) => ({
  currentNavStep: getCurrentNavStep(state, ownProps),
  ...ownProps
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyNavProgressPanel)


// WEBPACK FOOTER //
// ./src/components/JourneyNavProgress/JourneyNavProgressPanel.js